import { render, staticRenderFns } from "./soiProfile.vue?vue&type=template&id=3bc4738e"
import script from "./soiProfile.vue?vue&type=script&lang=js"
export * from "./soiProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports